let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1yq9n")).then(() => parcelRequire('e8AS0'));